'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'beer-mug-empty';
var width = 512;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M336 80L80 80l0 352 256 0 0-63.4c0-.4 0-.7 0-1.1L336 80zm48 303.7l0 48.3 0 48-48 0L80 480l-48 0 0-48L32 80l0-48 48 0 256 0 48 0 0 48 0 16 104 0 24 0 0 24 0 192 0 15.7L497.6 334 384 383.7zM384 144l0 187.3 80-35L464 144l-80 0zM160 128l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0zm64 0l0 16 0 224 0 16-32 0 0-16 0-224 0-16 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;